<template>
  <div class="d-flex align-center justify-center" style="height: 100vh">
    <loading 
      v-model:active="isLoading"
      :can-cancel="false"
      :is-full-page="false"
      loader="bars"
      color="#EE6090"
      :width="50"
      :height="50"
      background-color="transparent"
      :opacity="1"
    />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';

import { auth0Module } from '@/store/entityModules/auth0';

const isLoading = ref(true);

</script>

<style scoped>
.justify-center {
  justify-content: center;
}
</style>